export const monthEventFilter = (event, monthNo ) => {
    const d = new Date(event.dateStart);
    return ( d.getMonth() ===  monthNo );
  };
export const divisionRankingFilter = (dataItem, division ) => {
    return ( dataItem.division ===  division );
  };
export const divisionEventPowerPointsFilter = (dataItem, division ) => {
    return ( dataItem.division ===  division );
  };

export const divisionTeamPowerPointsFilter = (dataItem, division, tier ) => {
    return ( dataItem.division ===  division && dataItem.t1no === tier);
  };
  export const divisionTeamPowerPointsCombinedFilter = (dataItem, division ) => {
    return ( dataItem.division ===  division );
  };
export const divisionEventAverageFilter = (dataItem, division ) => {
  // const neverUsed = isVarsity;
  // isVarsity = neverUsed;
  // return ( dataItem.division ===  division);
  return ( dataItem.division ===  division );
  };
  
export const teamStandingsFilter = (dataItem, division, isVarsity ) => {
    return ( dataItem.division ===  division && dataItem.varsity === isVarsity );
  };  

export const divisionSchoolAverageFilter = (dataItem, division, isVarsity ) => {
    return ( dataItem.division ===  division && dataItem.isVarsity === isVarsity );
    };

export const divisionPlayerFilter = (dataItem, division ) => {
    return ( dataItem.divisionMale ===  division );
  };    


// WEBPACK FOOTER //
// ./src/utils/functions/filters.js